module.exports = "<div class=\"site\">\n    <app-header></app-header>\n    <router-outlet></router-outlet>\n</div>"